// slide
import Splide from "@splidejs/splide";

require("./plugins/mapify/jquery.mapify");

if ($(".proyecto-townhouse #atributos-slide").length) {
    new Splide("#atributos-slide", {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        arrows: false,
        pagination: true,
        breakpoints: {
            992: {
                perPage: 2,
            },
            768: {
                perPage: 1,
            },
        },
    }).mount();
}

if ($(".proyecto-townhouse #items-galeria-slide").length) {
    new Splide("#items-galeria-slide", {
        type: "loop",
        perPage: 1,
        perMove: 1,
        autoplay: true,
        arrows: true,
        pagination: false,
    }).mount();
}

$(".proyecto-townhouse  #modelos .img-mapeada").mapify({
    popOver: {
        content: function (zone) {
            var top = $(".mapify-svg .mapify-hover").offset().top;
            var html_popup = "<strong>" + zone.attr("data-title") + "</strong>";
            return html_popup;
        },
        delay: 0.7,
        margin: "auto",
        height: "60px",
        width: "200px",
    },
});
/* $(".area-modelo").on("click", function (event) {
    event.preventDefault();
    var id = $(this).data("id");
    $("#" + id).modal("show");
}); */
